export * from './FAQ';
